import MainNav from "../MainNav/MainNav"

const ContactUs = () => {
   return (
      <>
         <MainNav />
         <div className="RootLayout">
            <h1>ContactUs</h1>
         </div>
      </>
   )
}

export default ContactUs
